import * as angular from "angular";
import {IController} from "angular";


export class OrganizationsDetailsCtrl implements IController {

  constructor() {
  }

  $onInit() {
  }
}

angular
  .module('bringoz.admin.organizations')
  .component('organizationsDetails', {
    template: require('./organizations-details.html').default,
    controller: OrganizationsDetailsCtrl
  });
